import { uid } from "@/lib/store";

const PROG = [
  { root: 38, chord: [62, 65, 69] }, // Dm
  { root: 34, chord: [58, 62, 65] }, // Bb
  { root: 41, chord: [60, 65, 69] }, // F
  { root: 36, chord: [60, 64, 67] }, // C
];
const perBar = (bars, fn) => { const out = []; for (let b = 0; b < bars; b++) fn(b, b * 16, out); return out; };
const n = (s, p, l = 1, v = 0.8) => ({ id: uid("n"), s, p, l, v });

export const PATTERNS = {
  groove: (bars) => perBar(bars, (b, o, out) => {
    [0, 6, 10].forEach((s) => out.push(n(o + s, 36, 1, 1)));
    [4, 12].forEach((s) => out.push(n(o + s, 38, 1, 0.9)));
    for (let s = 0; s < 16; s += 2) out.push(n(o + s, 42, 1, s % 4 ? 0.5 : 0.75));
    if (b % 4 === 3) out.push(n(o + 14, 46, 2, 0.6));
  }),
  fourFloor: (bars) => perBar(bars, (b, o, out) => {
    [0, 4, 8, 12].forEach((s) => out.push(n(o + s, 36, 1, 1)));
    [4, 12].forEach((s) => out.push(n(o + s, 39, 1, 0.8)));
    [2, 6, 10, 14].forEach((s) => out.push(n(o + s, 46, 1, 0.5)));
  }),
  trap: (bars) => perBar(bars, (b, o, out) => {
    [0, 7, 10].forEach((s) => out.push(n(o + s, 36, 1, 1)));
    out.push(n(o + 8, 38, 1, 1)); out.push(n(o + 8, 39, 1, 0.6));
    for (let s = 0; s < 16; s++) if (s % 2 === 0 || (b % 2 && s > 11)) out.push(n(o + s, 42, 1, 0.45 + (s % 4 ? 0 : 0.2)));
  }),
  funk: (bars) => perBar(bars, (b, o, out) => {
    [0, 3, 10].forEach((s) => out.push(n(o + s, 36, 1, 1)));
    [4, 12].forEach((s) => out.push(n(o + s, 38, 1, 1)));
    [7, 9, 15].forEach((s) => out.push(n(o + s, 38, 1, 0.3)));
    for (let s = 0; s < 16; s++) out.push(n(o + s, 42, 1, s % 2 ? 0.3 : 0.6));
  }),
  bass: (bars) => perBar(bars, (b, o, out) => {
    const r = PROG[b % 4].root;
    out.push(n(o, r, 3, 0.95)); out.push(n(o + 3, r, 2, 0.7)); out.push(n(o + 6, r, 2, 0.8)); out.push(n(o + 10, r + 12, 2, 0.8)); out.push(n(o + 14, r + 7, 2, 0.7));
  }),
  octBass: (bars) => perBar(bars, (b, o, out) => { const r = PROG[b % 4].root; for (let s = 0; s < 16; s += 2) out.push(n(o + s, s % 4 ? r + 12 : r, 1, 0.85)); }),
  chords: (bars) => perBar(bars, (b, o, out) => { PROG[b % 4].chord.forEach((p) => { out.push(n(o, p, 6, 0.7)); out.push(n(o + 8, p, 6, 0.6)); }); }),
  skank: (bars) => perBar(bars, (b, o, out) => { [2, 6, 10, 14].forEach((s) => PROG[b % 4].chord.forEach((p) => out.push(n(o + s, p, 1, 0.65)))); }),
  pad: (bars) => perBar(bars, (b, o, out) => { PROG[b % 4].chord.forEach((p) => out.push(n(o, p - 12, 16, 0.6))); }),
  arp: (bars) => perBar(bars, (b, o, out) => { const c = PROG[b % 4].chord; for (let s = 0; s < 16; s++) out.push(n(o + s, c[s % 3] + (s % 6 > 2 ? 12 : 0), 1, 0.6)); }),
  melody: (bars) => {
    const m = [[0, 74, 3], [4, 72, 2], [6, 69, 4], [12, 67, 2], [14, 69, 2], [16, 70, 6], [24, 69, 2], [26, 65, 6], [32, 69, 3], [36, 72, 3], [40, 74, 4], [46, 72, 2], [48, 72, 4], [52, 71, 2], [54, 67, 8]];
    const out = []; for (let rep = 0; rep < bars / 4; rep++) m.forEach(([s, p, l]) => out.push(n(rep * 64 + s, p, l, 0.8))); return out;
  },
};

export const LOOPS = [
  { id: "groove", name: "Pocket Groove 92", cat: "Drums", inst: "drums", bars: 4 },
  { id: "fourFloor", name: "Four On The Floor", cat: "Drums", inst: "drums", bars: 4 },
  { id: "trap", name: "Trap Hats 140", cat: "Drums", inst: "drums", bars: 4 },
  { id: "funk", name: "Ghost Note Funk", cat: "Drums", inst: "drums", bars: 4 },
  { id: "bass", name: "Syncopated Bass", cat: "Bass", inst: "bass", bars: 4 },
  { id: "octBass", name: "Octave Disco Bass", cat: "Bass", inst: "bass", bars: 4 },
  { id: "chords", name: "Neo-Soul Chords", cat: "Keys", inst: "keys", bars: 4 },
  { id: "skank", name: "Offbeat Stabs", cat: "Keys", inst: "keys", bars: 4 },
  { id: "pad", name: "Warm Pad Bed", cat: "Synth", inst: "pad", bars: 4 },
  { id: "arp", name: "Rolling Arp", cat: "Synth", inst: "pluck", bars: 4 },
  { id: "melody", name: "Topline Hook", cat: "Synth", inst: "lead", bars: 4 },
];

export const TRACK_COLORS = ["#f59e0b", "#38bdf8", "#34d399", "#a78bfa", "#f472b6", "#f87171", "#facc15", "#2dd4bf", "#fb923c", "#818cf8"];

export const mkClip = (start, length, pattern, name) => ({ id: uid("c"), name: name || "Clip", start, length, notes: pattern ? PATTERNS[pattern](length) : [] });

export const mkTrack = (name, instrument, color, clips = [], extra = {}) => ({
  id: uid("t"), name, instrument, color, volume: 0.78, pan: 0, mute: false, solo: false, arm: false,
  eq: { low: 0, mid: 0, high: 0 }, eqOn: true, sendRev: 0.1, sendDly: 0, cutoff: 0.7, transpose: 0, clips, ...extra,
});

export const defaultSong = () => ({
  title: "Midnight Pocket",
  bpm: 92, bars: 32, loopOn: true, loop: [0, 8], masterVol: 0.85, sig: "4/4",
  tracks: [
    mkTrack("Drums", "drums", "#f59e0b", [mkClip(0, 4, "groove", "Groove A"), mkClip(4, 4, "funk", "Groove B"), mkClip(8, 8, "groove", "Groove A")], { sendRev: 0.05 }),
    mkTrack("Bass", "bass", "#38bdf8", [mkClip(0, 8, "bass", "Bassline"), mkClip(8, 8, "octBass", "Disco Bass")], { sendRev: 0 }),
    mkTrack("E-Piano", "keys", "#34d399", [mkClip(0, 8, "chords", "Chords"), mkClip(8, 8, "skank", "Stabs")], { sendRev: 0.25, pan: -0.2 }),
    mkTrack("Pad", "pad", "#a78bfa", [mkClip(4, 12, "pad", "Pad Bed")], { volume: 0.6, sendRev: 0.4, pan: 0.15 }),
    mkTrack("Lead", "lead", "#f472b6", [mkClip(8, 8, "melody", "Hook")], { volume: 0.62, sendRev: 0.2, sendDly: 0.25 }),
  ],
});
